import { apiGet } from "../client";

export async function fetchAdminDashboardOverview() {
  return apiGet("/admin/reports/dashboard-overview");
}

export async function fetchAdminStudentReport(studentId) {
  return apiGet(`/admin/reports/student/${studentId}`);
}

export async function fetchAdminStudentPathsReport(studentId) {
  return apiGet(`/admin/reports/student/${studentId}/paths`);
}

export async function fetchAdminStudentCompletions(studentId) {
  return apiGet(`/admin/reports/student/${studentId}/completions`);
}
